import type { PiiLookupDocumentDto } from "@babackapp/private-api-client/generated/schema";
import { Badge } from "@babackapp/ui/components/badge";

/** Worst-case summary of a document's field comparisons, for a table row. */
export function PiiStatusCell({
  document,
}: {
  document: PiiLookupDocumentDto;
}) {
  if (!document.isRecordedInVault) {
    return <Badge variant="outline">Pas dans le coffre</Badge>;
  }
  const mismatches = document.comparisons.filter(
    (c) => c.status !== "match",
  ).length;
  if (mismatches === 0) {
    return (
      <Badge variant="outline" className="bg-green-100 text-green-800">
        OK
      </Badge>
    );
  }
  return (
    <Badge variant="outline" className="bg-red-100 text-red-800">
      {mismatches} écart(s)
    </Badge>
  );
}
